export default __webpack_public_path__ + "static/media/brand4.51a52ed6.png";